/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { validateYupSchema, yupToFormErrors } from 'formik';
import { bankObject } from '../../components/investors/bankDetails';
//import { getDocumentDetails } from '../../components/investors/documentDetails';
import { contactPersonObject } from '../../components/NonIndividualInvestor/ContactDetails';
import { document_object } from '../../components/NonIndividualInvestor/DocumentDetails';
import { percentageError } from '../../components/NonIndividualInvestor/InvestorWithoutPan/ubo';
import {
  APPLICATION_TYPE_FOR_DOCUMENTS,
  bankType,
  FLOW_TYPE_MASTER,
  IS_PENNYDROP_APPLICABLE_FOR_AMC,
  Marital_Status,
  occupationDetailsMasters,
  relatedRelations,
  salutationsMasters,
  USER_ROLES,
} from '../../utils/constant';
import { emailRegex } from '../../utils/regex';
import {
  bankDetailsSchema,
  contributorDetailsSchemaWithoutPan,
  contributorDetailsSchemaWithPan,
  documentDetailsSchema,
  FATCAValidationSchema,
  KYCDetailsSchema,
  nomineeDetailsSchema,
  nonIndividualContactDetailsSchemaWithPan,
  NonIndividualContributorValidationSchema,
  NonIndividualContributorValidationSchemaWithPan,
  nonIndividualDocumentDetailsSchema,
} from '../../utils/schema';
import {
  getAddressData,
  getBankAddress,
  getNomineeRelation,
  getRelation,
  eddDocumentCheck,
  isMinor,
  isNaturalParent,
  isOnboardingTypeMinor,
  IsInvestorWithPAN,
  checkNriPIO,
  checkNormalNri,
  isNonResidentDeclaration,
  isNriAndPioStatus,
  getIsServiceRequired,
  IsOutBoundFundFlow,
  ifPushToXalt,
} from '../../utils/utilityFunctions';
import { AuthorisedErrors, BankError, CALL_API, UboErrors } from '../middleware';

import {
  Applicant,
  ApplicationProps,
  Bank,
  NomineeType,
  Document,
  uboTypes,
  FetchUBORequestBody,
  StampPapersType,
  dashboardOnboardingType,
  monthwiseOnboardingSummaryType,
  distributorWisecommitmentType,
  monthwiseCommitmentAmountType,
  FatcaMdms,
  individuals_Poa_nonIndividuals_Documents,
  Groups,
  GroupSignatories,
  uboDomestic,
  uboForeign,
  // RtaSendBackType,
} from '../types/api-types';
import {
  CreateApplicationRequestBody,
  CREATE_APPLICATION,
  CREATE_APPLICATION_SUCCESS,
  GET_APPLICATION,
  GET_APPLICATION_SUCCESS,
  GET_ALL_APPLICATION_SUCCESS,
  GET_STAMPPAPER_DETAILS_SUCCESS,
  GET_STAMPPAPER_DETAILS,
  GET_DISTRIBUTOR_COMMITMENTAMOUNT_SUCCESS,
  GET_DISTRIBUTOR_COMMITMENTAMOUNT,
  GET_MONTHWISE_COMMITMENTAMOUNT_SUCCESS,
  GET_MONTHWISE_COMMITMENTAMOUNT,
  GET_ONBOARDING_SUMMARY_SUCCESS,
  GET_ONBOARDING_SUMMARY,
  GET_MONTHWISE_ONBOARDING_SUMMARY_SUCCESS,
  GET_MONTHWISE_ONBOARDING_SUMMARY,
  GET_ALL_APPLICATION,
  UPDATE_APPLICATION_SUCCESS,
  UPDATE_APPLICATION,
  AddJointHolderRequestBody,
  ADD_APPLICANT_SUCCESS,
  ADD_APPLICANT,
  GetAllApplicantsRequestBody,
  GetAllApplicantionsResponseBody,
  PENNY_DROP_VERIFICATION_SUCCESS,
  PENNY_DROP_VERIFICATION,
  GET_Documents_SUCCESS,
  GET_Documents,
  GET_Ubo_SUCCESS,
  GET_Ubo,
  UBO_LISTING_SUCCESS,
  UBO_LISTING,
  GET_Fatca_SUCCESS,
  GET_Fatca,
  createApplicationWithoutPANRequestBody,
  AddJointHolderWithoutPANRequestBody,
  CREATE_PHYSICAL_APPLICATION_SUCCESS,
  CREATE_PHYSICAL_APPLICATION,
} from '../types/application';
import { mdmsCountriesList, nationaliyType } from '../types/mdms';
import { fatcaDocumentCheck } from '../../components/investors/documentDetails';
import { percentageErrorWithPan } from '../../components/NonIndividualInvestor/InvestorWithPan/Ubo';
import { ValuesCKYCOnboarding } from '../../components/onboarding/enterCKYC';

export const createApplication =
  (flowType: string, body: CreateApplicationRequestBody) =>
  async (dispatch: any): Promise<ApplicationProps> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/applications${
          IsInvestorWithPAN(flowType) ? '' : '/create-taxid-application'
        }`,
        method: 'POST',
        types: [CREATE_APPLICATION_SUCCESS, CREATE_APPLICATION],
        body,
      },
    });
  };
export const createApplicationWithoutPan =
  (flowType: string, body: createApplicationWithoutPANRequestBody) =>
  async (dispatch: any): Promise<ApplicationProps> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/applications${
          IsInvestorWithPAN(flowType) ? '' : '/create-taxid-application'
        }`,
        method: 'POST',
        types: [CREATE_APPLICATION_SUCCESS, CREATE_APPLICATION],
        body,
      },
    });
  };
export const getApplicationDetails =
  (applicationId: string, method = '', actualStatus?: string) =>
  async (dispatch: any): Promise<ApplicationProps> => {
    const queryParam = actualStatus ? `?status=${actualStatus}` : '';
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/applications/${applicationId}${queryParam}`,
        method: method ? 'DELETE' : 'GET',
        types: [GET_APPLICATION_SUCCESS, GET_APPLICATION],
      },
    });
  };

export const getParams = (paramsObj: Partial<GetAllApplicantsRequestBody>) => ({
  type: 'GET_PARAMS_DATA',
  paramsObj,
});
export const getAllApplications =
  (params: Partial<GetAllApplicantsRequestBody>) =>
  async (dispatch: any): Promise<GetAllApplicantionsResponseBody> => {
    await dispatch(getParams(params));
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/applications`,
        method: 'GET',
        types: [GET_ALL_APPLICATION_SUCCESS, GET_ALL_APPLICATION],
        params: {
          limit: 10,
          sort: 'createdAt',
          order: 'DESC',
          ...params,
        },
      },
    });
  };

export const onboardingSummary =
  () =>
  async (dispatch: any): Promise<dashboardOnboardingType> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/dashboard/onboardingSummary`,
        method: 'GET',
        types: [GET_ONBOARDING_SUMMARY_SUCCESS, GET_ONBOARDING_SUMMARY],
      },
    });
  };

export const monthwiseOnboardingSummary =
  () =>
  async (dispatch: any): Promise<monthwiseOnboardingSummaryType> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/dashboard/monthwiseOnboardingSummary?months=4`,
        method: 'GET',
        types: [GET_MONTHWISE_ONBOARDING_SUMMARY_SUCCESS, GET_MONTHWISE_ONBOARDING_SUMMARY],
      },
    });
  };

export const distributorWisecommitmentAmount =
  (currency: string) =>
  async (dispatch: any): Promise<distributorWisecommitmentType> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/dashboard/distributorWisecommitmentAmount`,
        method: 'GET',
        types: [GET_DISTRIBUTOR_COMMITMENTAMOUNT_SUCCESS, GET_DISTRIBUTOR_COMMITMENTAMOUNT],
        params: {
          currencyType: currency,
        },
      },
    });
  };

export const monthwiseCommitmentAmount =
  (currency: string) =>
  async (dispatch: any): Promise<monthwiseCommitmentAmountType> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/dashboard/monthwiseCommitmentAmount`,
        method: 'GET',
        types: [GET_MONTHWISE_COMMITMENTAMOUNT_SUCCESS, GET_MONTHWISE_COMMITMENTAMOUNT],
        params: {
          currencyType: currency,
        },
      },
    });
  };

// export const getStampPaperCount =
//   (params: Partial<GetAllApplicantsRequestBody>) =>
//   async (dispatch: any): Promise<GetAllApplicantionsResponseBody> => {
//     return await dispatch({
//       [CALL_API]: {
//         url: `/leegality/stampPaperDetails`,
//         method: 'GET',
//         types: [GET_STAMPPAPER_DETAILS_SUCCESS, GET_STAMPPAPER_DETAILS],

//       },
//     });
//   };

export const getStampPaperCount =
  () =>
  async (dispatch: any): Promise<StampPapersType> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/leegality/stampPaperDetails`,
        method: 'GET',
        types: [GET_STAMPPAPER_DETAILS_SUCCESS, GET_STAMPPAPER_DETAILS],
      },
    });
  };

export const updateApplication =
  ({
    body,
    applicationId,
    toastMessage,
    flowType,
  }: {
    body: Partial<ApplicationProps>;
    applicationId: string;
    toastMessage?: string;
    flowType: string;
  }) =>
  async (dispatch: any): Promise<ApplicationProps> => {
    const showToast = typeof toastMessage !== 'undefined';
    if (showToast) {
      toastMessage =
        `Application ${body.applicationNumber || ''} - ` + (toastMessage || ' Saved successfully');
    }
    try {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/applications/${applicationId}/${
            IsInvestorWithPAN(flowType) ? 'update' : 'taxIdNumberApplication-update'
          }`,
          method: 'POST',
          types: [UPDATE_APPLICATION_SUCCESS, UPDATE_APPLICATION],
          body,
          showToast,
          toastMessage,
        },
      });
    } catch (error: any) {
      console.log('catch error on update application', error);
      throw error;
    }
  };

// export const updateApplicationByRTA =
//   ({ body, applicationId }: { body: RtaSendBackType; applicationId: string }) =>
//   async (dispatch: any): Promise<ApplicationProps> => {
//     return await dispatch({
//       [CALL_API]: {
//         url: `/onboarding/applications/${applicationId}/update-for-rta`,
//         method: 'POST',
//         types: [UPDATE_APPLICATION_SUCCESS, UPDATE_APPLICATION],
//         body,
//       },
//     });
//   };

export const addJointHolder =
  (body: AddJointHolderRequestBody, applicationId: string, flowType: string) =>
  async (dispatch: any): Promise<ApplicationProps> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/applications/${applicationId}/${
          IsInvestorWithPAN(flowType) ? 'addApplicant' : 'addTaxIdApplicant'
        }`,
        method: 'POST',
        types: [ADD_APPLICANT_SUCCESS, ADD_APPLICANT],
        body,
      },
    });
  };

export const addJointHolderWithoutPan =
  (body: AddJointHolderWithoutPANRequestBody, applicationId: string, flowType: string) =>
  async (dispatch: any): Promise<ApplicationProps> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/applications/${applicationId}/${
          IsInvestorWithPAN(flowType) ? 'addApplicant' : 'addTaxIdApplicant'
        }`,
        method: 'POST',
        types: [ADD_APPLICANT_SUCCESS, ADD_APPLICANT],
        body,
      },
    });
  };

export const createApplicationWithCKYC =
  (body: ValuesCKYCOnboarding) =>
  async (dispatch: any): Promise<ApplicationProps> => {
    const { applicationType, ...rest } = body;
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/onboarding/initiate-onboarding`,
        method: 'POST',
        types: [CREATE_APPLICATION_SUCCESS, CREATE_APPLICATION],
        body: rest,
      },
    });
  };
export const addJointHolderWithCKYC =
  (body: ValuesCKYCOnboarding, applicationId: string) =>
  async (dispatch: any): Promise<ApplicationProps> => {
    console.log('addJointHolderWithCKYC body', body);
    const { applicationType, ...rest } = body;
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/onboarding/${applicationId}/initiate-onboarding`,
        method: 'POST',
        types: [ADD_APPLICANT_SUCCESS, ADD_APPLICANT],
        body: rest,
      },
    });
  };

export const validateContributorDetailsWithoutPan = async (
  applicants: Partial<Applicant>[],
  role: any,
  nationalitiesMdmsMasters: nationaliyType,
  folio_no: string | null | undefined,
  applicationSource: string | undefined,
  ifXalt: boolean
) => {
  const schemaData = {
    folio_no: folio_no,
    applicationSource: applicationSource || 'digitalonboarding',
    applicants: applicants.map((applicant) => ({
      ...applicant,
      status: applicant.status || 'Individual',
      namePrefix:
        applicant.namePrefix && salutationsMasters.includes(applicant.namePrefix || '')
          ? applicant.namePrefix
          : 'Mr.',
      jointApplicantRelation: applicant.relationShipWithFirstApplicant
        ? getRelation(applicant.relationShipWithFirstApplicant)
          ? applicant.relationShipWithFirstApplicant
          : 'Others'
        : '',
      relationShipWithFirstApplicant: getRelation(applicant.relationShipWithFirstApplicant)
        ? ''
        : applicant.relationShipWithFirstApplicant,
      minorPan: applicant.minorPan || '',
      minorDOB: applicant.minorDOB || null,
      minorName: applicant.minorName || '',
      guardianRelationship:
        (relatedRelations.includes(applicant.guardianRelationship as string)
          ? applicant.guardianRelationship
          : applicant.guardianRelationship
          ? 'OTHERS'
          : applicant.guardianRelationship) || '',
      guardianRelationshipTypeOther:
        (relatedRelations.includes(applicant.guardianRelationship as string)
          ? ''
          : applicant.guardianRelationship) || '',
      minorFatherName: applicant.minorFatherName || '',
      naturalParent: applicant.naturalParent || '',
      minorGender: applicant.minorGender || '',
      minorMobile: applicant.minorMobile || '',
      minorCountryNameAndCode: applicant.minorCountryNameAndCode || 'India: +91',
      minorEmail: applicant.minorEmail || '',
      minorNamePrefix: applicant.minorNamePrefix || 'Mr.',
      minorCountryCode: applicant.minorCountryCode || '+91',
      onboardingIdType: applicant.onboardingIdType,
      onboardingIdTypeOthers: applicant.onboardingIdTypeOthers,
      panDeclaration: applicant.panDeclaration ? applicant.panDeclaration : false,
      taxResidencyDocumentType: applicant.taxResidencyDocumentType || '',
    })),
    nationalityDropdown: nationalitiesMdmsMasters.countries
      .concat(nationalitiesMdmsMasters.eddCountries)
      .map((list) => list?.name),
  };
  try {
    await validateYupSchema(
      schemaData,
      contributorDetailsSchemaWithoutPan(ifXalt),
      true,
      schemaData
    );
  } catch (error) {
    throw `Contributor details`;
  }
};

export const validateContributorDetailsWithPan = async (
  applicants: Partial<Applicant>[],
  role: any,
  nationalitiesMdmsMasters: nationaliyType,
  fundFlowType: string,
  ifXalt: boolean
) => {
  const schemaData = {
    applicants: applicants.map((applicant) => ({
      ...applicant,
      nationality: applicant.nationality
        ? applicant.nationality.toUpperCase()
        : [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)
        ? ''
        : 'INDIAN',
      status: checkNriPIO(applicant.status as string, applicant.statusSubType as string)
        ? 'NRI_PIO'
        : applicant.status,
      namePrefix:
        applicant.namePrefix && salutationsMasters.includes(applicant.namePrefix || '')
          ? applicant.namePrefix
          : '',
      jointApplicantRelation: applicant.relationShipWithFirstApplicant
        ? getRelation(applicant.relationShipWithFirstApplicant)
          ? applicant.relationShipWithFirstApplicant
          : 'Others'
        : '',
      relationShipWithFirstApplicant: getRelation(applicant.relationShipWithFirstApplicant)
        ? ''
        : applicant.relationShipWithFirstApplicant,
      minorDOB: applicant.minorDOB || null,
      minorCountryNameAndCode: applicant.minorCountryNameAndCode || 'India: +91',
      minorNamePrefix: applicant.minorNamePrefix || '',
      minorCountryCode: applicant.minorCountryCode || '+91',
      taxResidencyDocumentType: applicant.taxResidencyDocumentType || '',
      nriPioContactedPersonName: isNriAndPioStatus(applicant?.status || '')
        ? applicant.nriPioContactedPersonName
        : '',
      maritalStatus:
        applicant.maritalStatus && Marital_Status[applicant.maritalStatus as string]
          ? applicant.maritalStatus
          : 'Other',
      otherMaritalStatus:
        applicant.maritalStatus && !Marital_Status[applicant.maritalStatus as string]
          ? applicant.maritalStatus
          : '',
    })),
    nationalityDropdown: nationalitiesMdmsMasters.countries
      .concat(nationalitiesMdmsMasters.eddCountries)
      .map((list) => list?.name),

    fundFlowType,
  };
  try {
    await validateYupSchema(
      schemaData,
      contributorDetailsSchemaWithPan(fundFlowType, ifXalt),
      true,
      schemaData
    );
  } catch (error) {
    throw `Contributor details`;
  }
};

export const validateKYCDetails = async (
  applicants: Partial<Applicant>[],
  role: any,
  flowType: string,
  createdAt: string,
  fundFlowType: string
) => {
  const schemaData = {
    applicants: applicants.map((applicant) => ({
      ...applicant,
      occupationDetails: applicant.occupationDetails || '',
      otherOccupationDetails: applicant.otherOccupationDetails || '',
      grossAnnualIncome: applicant.grossAnnualIncome || '',
      politicallyExposedPersonStatus: applicant.politicallyExposedPersonStatus
        ? applicant.politicallyExposedPersonStatus
        : [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)
        ? ''
        : 'I am Not a PEP',
      relationshipWithPep: applicant.relationshipWithPep || '',
      sourceOfFunds: applicant.sourceOfFunds
        ? (applicant.sourceOfFunds as string)?.split('*')
        : null,
      otherSourceOfFund: applicant.otherSourceOfFund || '',
      fundsOriginateFrom: applicant.fundsOriginateFrom
        ? (applicant.fundsOriginateFrom as string)?.split('*')
        : null,
      sourceWithinIndiaApproval: applicant.sourceWithinIndiaApproval || false,
      sourceWithinIndiaNoApproval: applicant.sourceWithinIndiaNoApproval || false,
      sourceOfFundsDeclaration: applicant.sourceOfFundsDeclaration || true,
      fundsDeclaration: applicant.fundsDeclaration || true,
      netWorth: applicant.netWorth || '',
      netWorthdate: applicant.netWorthDate || null,
      nameOfEmployer: applicant.nameOfEmployer || '',
      placeOfWork: applicant.placeOfWork || '',
      nameOfBusiness: applicant.nameOfBusiness || '',
      natureOfBusiness: applicant.natureOfBusiness || '',
      registeredAddress: applicant.registeredAddress || '',
    })),
    flowType: flowType,
    fundFlowType: fundFlowType,
    createdAt: createdAt,
  };
  try {
    await validateYupSchema(schemaData, KYCDetailsSchema(createdAt), true, schemaData);
  } catch (error) {
    console.log(error);
    throw `KYC details`;
  }
};

export const validateFATCA = async (
  applicants: Partial<Applicant>[],
  role: any,
  nationalitiesMdmsMasters: nationaliyType,
  flowType: string,
  fundFlowType: string
) => {
  const schemaData = {
    applicants: applicants?.map((applicant) => ({
      // typeOfAddressProvidedAtKRA: applicant.typeOfAddressProvidedAtKRA || '',
      taxIdResidentOfAnyCountryOtherThanIndia:
        applicant.taxIdResidentOfAnyCountryOtherThanIndia || 'Yes',
      placeOfBirth: applicant.placeOfBirth || '',
      countryOfBirth: applicant.countryOfBirth || applicant.nationality || '',
      countryOfNationality: applicant.countryOfNationality || applicant.nationality || '',
      // countryOfResidence: applicant.countryOfResidence || '',
      taxCountryName: applicant.taxCountryName || '',
      taxID: applicant.taxID || applicant.taxIdNumber || '',
      idType: applicant.idType || 'TIN' || '',
      nameOfEntity: applicant.nameOfEntity || '',
      dateOfIncorporation: applicant.dateOfIncorporation || '',
      cityOfIncorporation: applicant.cityOfIncorporation || '',
      countryOfIncorporation: applicant.countryOfIncorporation || '',
      entityExcemptionCode: applicant.entityExcemptionCode || '',
      idTypeOthers: applicant.idTypeOthers || '',
      tinNotAvailableReason: applicant.tinNotAvailableReason || '',
      othersTinNotAvailableReason: applicant.othersTinNotAvailableReason || '',
      usPerson: applicant.usPerson || '',
      fatcaDeclaration: !IsOutBoundFundFlow(fundFlowType)
        ? applicant.fatcaDeclaration || true
        : false,
      wishToUploadFatcaDocument: applicant.wishToUploadFatcaDocument,
    })),
    fundFlowType: fundFlowType,
    flowType: flowType,
    countryDropdown: nationalitiesMdmsMasters.countries
      .concat(nationalitiesMdmsMasters.eddCountries)
      .map((list) => list?.name),
    countriesOfBirthList: nationalitiesMdmsMasters.countries
      .concat(nationalitiesMdmsMasters.eddCountries)
      .concat(nationalitiesMdmsMasters.blackListCountries)
      .map((list) => list?.name),
  };
  try {
    await validateYupSchema(schemaData, FATCAValidationSchema, true, schemaData);
  } catch (error) {
    throw `FATCA`;
  }
};

export const validateNomineeDetails = async (
  Nominees: Partial<NomineeType>[],
  doNotWishToNominate: boolean,
  createdAt: string,
  ifXalt: boolean
) => {
  const schemaData = {
    doNotWishToNominate: doNotWishToNominate === null ? true : doNotWishToNominate,
    nominees: Nominees.length
      ? Nominees.map((nominee) => ({
          ...nominee,
          Relationship: nominee.nomineeRelationship
            ? getNomineeRelation(nominee.nomineeRelationship.toUpperCase())
              ? nominee.nomineeRelationship.toUpperCase()
              : 'OTHERS'
            : '',
          nomineeRelationship: getNomineeRelation(nominee.nomineeRelationship?.toUpperCase())
            ? ''
            : nominee.nomineeRelationship,
          guardianRelationship: getNomineeRelation(nominee.guardianRelationship?.toUpperCase())
            ? nominee.guardianRelationship?.toUpperCase() ?? ''
            : 'OTHERS',
          guardianRelationOther: getNomineeRelation(nominee.guardianRelationship?.toUpperCase())
            ? ''
            : nominee.guardianRelationship,
        }))
      : [],
  };
  try {
    await validateYupSchema(schemaData, nomineeDetailsSchema(ifXalt, createdAt), true, schemaData);
  } catch (error) {
    throw `Nominee details`;
  }
};

export const validateBankDetails = async (
  bankDetails: Partial<Bank>[],
  verifyPennydrop: boolean,
  applicationType: string,
  applicants: Partial<Applicant>[],
  ibanCountriesList: mdmsCountriesList[],
  createdAt: string,
  flowType: string,
  fundFlowType: string,
  paymentModeDeclaration: boolean
) => {
  const schemaData = {
    applicationType: applicationType,
    status: applicants.length ? applicants[0].status : '',
    banks: bankDetails.length
      ? bankDetails.map((bank) => ({
          ...bank,
          defaultBankAccount: bank.defaultBankAccount || true,
          bankAddress: getBankAddress(bank.address1, bank.address2, bank.address3),
          investorBankType: bank.investorBankType || 'overseas',
        }))
      : [bankObject],
    paymentModeDeclaration: paymentModeDeclaration,
  };
  try {
    if (IS_PENNYDROP_APPLICABLE_FOR_AMC && verifyPennydrop) {
      const isAllBanksPennyChecked = bankDetails
        .filter((bank) => bankType[bank.investorBankType || ''] === bankType.Domestic)
        .every((bank) => bank.pennydropCheck);
      if (!isAllBanksPennyChecked) {
        throw new BankError('Please make sure that all the banks are verified');
      }
    }
    await validateYupSchema(
      schemaData,
      bankDetailsSchema(applicants, ibanCountriesList ?? [], createdAt),
      true,
      schemaData
    );
  } catch (error) {
    if (error instanceof BankError) {
      throw error;
    }
    throw `Bank details`;
  }
};

export const validateDocuments = async (
  applicants: Partial<Applicant>[],
  applicationSource: string | undefined,
  hasPOA: boolean,
  documentsData: Document,
  Nominees: Partial<NomineeType>[],
  documentDeclarationCheck: boolean,
  nationalitiesMdmsMasters: nationaliyType,
  onboardingType: string,
  flowType: string,
  banks: Partial<Bank>[]
) => {
  const schemaData = {
    applicants: applicants.map((applicant, applicant_index) => {
      let docData = null;
      docData = isOnboardingTypeMinor(onboardingType)
        ? APPLICATION_TYPE_FOR_DOCUMENTS.MINOR
        : APPLICATION_TYPE_FOR_DOCUMENTS.INDIVIDUAL;
      if (checkNormalNri(applicant.status as string, applicant.statusSubType)) {
        docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI;
      }
      if (checkNriPIO(applicant.status as string, applicant.statusSubType as string)) {
        docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI_PIO;
      }
      // if (
      //   !hasPOA &&
      //   applicantStatusMasters[applicant.status as string] === applicantStatusMasters.Individual
      // ) {
      //   docData = APPLICATION_TYPE_FOR_DOCUMENTS.INDIVIDUAL;
      // }
      // if (
      //   hasPOA &&
      //   applicantStatusMasters[applicant.status as string] === applicantStatusMasters.Individual
      // ) {
      //   docData = APPLICATION_TYPE_FOR_DOCUMENTS.INDIVIDUAL_POA;
      // }
      // if (
      //   !hasPOA &&
      //   applicantStatusMasters[applicant.status as string] === applicantStatusMasters.NRI
      // ) {
      //   docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI;
      // }
      // if (
      //   hasPOA &&
      //   applicantStatusMasters[applicant.status as string] === applicantStatusMasters.NRI
      // ) {
      //   docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI_POA;
      // }
      return {
        documents:
          typeof documentsData !== 'undefined'
            ? ((documentsData as Document)[docData] || [])
                .filter((doc) => {
                  if (
                    hasPOA &&
                    applicant.applicant_type !== '1' &&
                    doc.documentType === 'poaNotarized'
                  ) {
                    return;
                  }
                  if (
                    !applicant?.taxResidencyDocumentType &&
                    ['form_10ff_trc', 'declaration_by_non_resident'].includes(doc.documentType)
                  ) {
                    return;
                  }
                  if (
                    isNonResidentDeclaration(applicant?.taxResidencyDocumentType) &&
                    doc.documentType === 'form_10ff_trc'
                  ) {
                    return;
                  }
                  if (
                    !isNonResidentDeclaration(applicant?.taxResidencyDocumentType) &&
                    doc.documentType === 'declaration_by_non_resident'
                  ) {
                    return;
                  }
                  if (
                    applicationSource !== 'migration' &&
                    doc.documentType === 'migration_document'
                  ) {
                    return;
                  }
                  if (
                    fatcaDocumentCheck(
                      !applicant.wishToUploadFatcaDocument as boolean,
                      doc.documentType
                    )
                  ) {
                    return;
                  }
                  if (
                    doc.documentType === 'edd_declaration' &&
                    !eddDocumentCheck(nationalitiesMdmsMasters?.eddCountries, applicant)
                  ) {
                    return;
                  }
                  if (
                    doc.documentType === 'proofOfRelation' &&
                    !isNaturalParent(applicant.naturalParent || '')
                  ) {
                    return;
                  }
                  if (doc.documentType === 'agreementForUsPerson' && applicant.usPerson !== 'Yes') {
                    return;
                  }
                  if (applicant.applicant_type !== '1' && doc.documentType === 'bankAccountProof') {
                    return;
                  }
                  if (
                    applicant.applicant_type === '1' &&
                    banks[0].pennydropVerified &&
                    doc.documentType === 'bankAccountProof'
                  ) {
                    return;
                  }
                  return doc;
                })
                .filter((ele) => ele)
                .map((_doc) => {
                  const { permanentAddressSameAsCorresponding = true } =
                    applicant?.addresses?.find(
                      (address) => address.address_type === 'correspondence'
                    ) || {};
                  if (
                    (!IsInvestorWithPAN(flowType)
                      ? !permanentAddressSameAsCorresponding
                      : applicant.correspondenceAddressEdited) &&
                    ['correspondenceAddressProof', 'correspondenceAddress'].includes(
                      _doc.documentType
                    )
                  ) {
                    return { ..._doc, required: 'true' };
                  }
                  if (_doc.documentType === 'agreementForUsPerson') {
                    return { ..._doc, required: 'true' };
                  }
                  if (
                    applicationSource === 'migration' &&
                    _doc.documentType === 'migration_document'
                  ) {
                    return { ..._doc, required: 'true' };
                  }
                  if (
                    fatcaDocumentCheck(
                      applicant.wishToUploadFatcaDocument as boolean,
                      _doc.documentType
                    )
                  ) {
                    return { ..._doc, required: 'true' };
                  }
                  if (
                    _doc.documentType === 'edd_declaration' &&
                    eddDocumentCheck(nationalitiesMdmsMasters?.eddCountries, applicant)
                  ) {
                    return { ..._doc, required: 'true' };
                  }
                  if (
                    _doc.documentType === 'proofOfRelation' &&
                    isNaturalParent(applicant.naturalParent || '')
                  ) {
                    return { ..._doc, required: 'true' };
                  }
                  if (
                    applicant.applicant_type === '1' &&
                    !banks[0].pennydropVerified &&
                    _doc.documentType === 'bankAccountProof'
                  ) {
                    return { ..._doc, required: 'true' };
                  }
                  if (
                    !isNonResidentDeclaration(applicant?.taxResidencyDocumentType) &&
                    _doc.documentType === 'form_10ff_trc'
                  ) {
                    return { ..._doc, required: 'true' };
                  }
                  if (
                    isNonResidentDeclaration(applicant?.taxResidencyDocumentType) &&
                    _doc.documentType === 'declaration_by_non_resident'
                  ) {
                    return { ..._doc, required: 'true' };
                  }
                  return _doc;
                })
                .filter((document) => {
                  if (applicant.amlCheck && document.documentType === 'compliance_document') {
                    return;
                  }
                  return document;
                })
                .filter((ele) => ele)
                .map((doc: individuals_Poa_nonIndividuals_Documents, index: number) => {
                  const {
                    documentType,
                    documentName,
                    multipleFiles,
                    required,
                    options,
                    infoText,
                    downloadTemplate,
                  } = doc;
                  const { documents: existingDocuments = [] } = applicant || {};
                  const docsOfCurrentDocType = existingDocuments
                    .filter((doc) => doc.documentType === documentType)
                    .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId));
                  return {
                    documentType: documentType,
                    documentName: documentName,
                    documentsList: docsOfCurrentDocType.length
                      ? docsOfCurrentDocType.map((doc, ind) => {
                          const {
                            documentName = '',
                            documentType = '',
                            documentId = '',
                            isActive = true,
                            file = undefined,
                          } = doc;
                          return {
                            documentType,
                            documentName,
                            documentId,
                            isActive,
                            file,
                            options,
                            required,
                            infoText,
                            downloadTemplate,
                            uniqueKey: (applicant_index.toString() +
                              '-' +
                              index.toString() +
                              '-' +
                              ind.toString()) as string,

                            errorOnUpload: document_object.errorOnUpload,
                          };
                        })
                      : [
                          {
                            documentType,
                            documentName,
                            required,
                            options,
                            infoText,
                            downloadTemplate,
                            uniqueKey: (applicant_index.toString() +
                              '-' +
                              index.toString() +
                              '-' +
                              '0') as string,
                            ...document_object,
                          },
                        ],
                    required,
                    multipleFiles,
                    options,
                    downloadTemplate,
                    infoText,
                  };
                })
            : [],
      };
    }),
    nominees: Nominees.map((nominee, nominee_index) => {
      return {
        nomineedocuments:
          typeof documentsData !== 'undefined'
            ? (isMinor(nominee.dateOfBirth || '')
                ? [
                    ...((documentsData as Document)[APPLICATION_TYPE_FOR_DOCUMENTS.NOMINEE_DOC] ||
                      []),
                    ...((documentsData as Document)[
                      APPLICATION_TYPE_FOR_DOCUMENTS.NOMINEE_GUARDIAN
                    ] || []),
                  ].map((doc) => {
                    if (['nomineeIdProof', 'nomineePhotoIdProof'].includes(doc.documentType)) {
                      return { ...doc, required: 'false' };
                    }
                    return doc;
                  })
                : (documentsData as Document)[APPLICATION_TYPE_FOR_DOCUMENTS.NOMINEE_DOC] || []
              )
                .filter((doc) => !['nomineeIdProof', 'guardianIdProof'].includes(doc.documentType))
                .map((doc: individuals_Poa_nonIndividuals_Documents, index: number) => {
                  const { documentType, documentName, multipleFiles, required, options } = doc;
                  const { nomineedocuments: existingDocuments = [] } = nominee || {};
                  const docsOfCurrentDocType = existingDocuments
                    .filter((doc) => doc.documentType === documentType)
                    .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId));
                  return {
                    documentType: documentType,
                    documentName: documentName,
                    documentsList: docsOfCurrentDocType.length
                      ? docsOfCurrentDocType.map((doc, ind) => {
                          const {
                            documentName = '',
                            documentType = '',
                            documentId = '',
                            isActive = true,
                            file = undefined,
                          } = doc;
                          return {
                            documentType,
                            documentName,
                            documentId,
                            isActive,
                            file,
                            options,
                            required,
                            uniqueKey: (nominee_index.toString() +
                              '-' +
                              index.toString() +
                              '-' +
                              ind.toString()) as string,
                            errorOnUpload: document_object.errorOnUpload,
                          };
                        })
                      : [
                          {
                            documentType,
                            documentName,
                            required,
                            options,
                            uniqueKey: (nominee_index.toString() +
                              '-' +
                              index.toString() +
                              '-' +
                              '0') as string,
                            ...document_object,
                          },
                        ],
                    required,
                    multipleFiles,
                    options,
                  };
                })
            : [],
      };
    }),
    documentDeclarationCheck,
  };
  try {
    await validateYupSchema(schemaData, documentDetailsSchema, true, schemaData);
  } catch (error) {
    throw `Document details`;
  }
};

export const isFormValidForSubmission = async (
  application: ApplicationProps | null,
  validateDoc = true,
  verifyPennydrop = true,
  nationalitiesMdmsMasters = {},
  documentsResponse = {},
  role = ''
) => {
  const {
    applicants = [],
    nominees = [],
    doNotWishToNominate = false,
    banks = [],
    hasPOA = true,
    folio_no,
    applicationSource = '',
    applicationType = '',
    documentDeclarationCheck = false,
    onboardingType = '',
    flowType = '',
    fundFlowType = '',
    createdAt = '',
  } = application || {};

  try {
    IsInvestorWithPAN(flowType)
      ? await validateContributorDetailsWithPan(
          applicants,
          role,
          nationalitiesMdmsMasters as nationaliyType,
          fundFlowType,
          ifPushToXalt(application?.pushDataTo || '')
        )
      : await validateContributorDetailsWithoutPan(
          applicants,
          role,
          nationalitiesMdmsMasters as nationaliyType,
          folio_no,
          applicationSource,
          ifPushToXalt(application?.pushDataTo || '')
        );
    await validateKYCDetails(applicants, role, flowType, createdAt, fundFlowType);
    await validateFATCA(
      applicants,
      role,
      nationalitiesMdmsMasters as nationaliyType,
      flowType,
      fundFlowType
    );
    await validateNomineeDetails(
      nominees,
      doNotWishToNominate,
      createdAt,
      ifPushToXalt(application?.pushDataTo || '')
    );
    await validateBankDetails(
      banks,
      verifyPennydrop,
      applicationType,
      applicants,
      (nationalitiesMdmsMasters as nationaliyType)?.ibanCountries || [],
      createdAt,
      flowType,
      fundFlowType,
      application?.paymentModeDeclaration || false
    );
    validateDoc &&
      Object.keys(documentsResponse).length !== 0 &&
      (await validateDocuments(
        applicants,
        application?.applicationSource,
        hasPOA,
        documentsResponse as Document,
        nominees,
        documentDeclarationCheck,
        nationalitiesMdmsMasters as nationaliyType,
        onboardingType,
        flowType,
        application?.banks || []
      ));
  } catch (error) {
    if (error instanceof BankError) {
      throw (error as BankError).message;
    }
    throw `In ${error}, the required fields are not filled.`;
  }
};

export const pennyDropVerification =
  (body: Bank) =>
  async (dispatch: any): Promise<Bank> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/pennydropverification`,
        method: 'POST',
        types: [PENNY_DROP_VERIFICATION_SUCCESS, PENNY_DROP_VERIFICATION],
        body,
      },
    });
  };

export const getDocuments =
  (flowType: string, fundFlowType: string) =>
  async (dispatch: any): Promise<Document> => {
    return await dispatch({
      [CALL_API]: {
        url: `/mdms/${
          IsInvestorWithPAN(flowType)
            ? `domestic_document_master_${fundFlowType}.json`
            : 'required_document_master.json'
        }`,
        method: 'GET',
        types: [GET_Documents_SUCCESS, GET_Documents],
      },
    });
  };

export const getUboTypes =
  () =>
  async (dispatch: any): Promise<uboTypes> => {
    return await dispatch({
      [CALL_API]: {
        url: '/mdms/uboTypeMaster.json',
        method: 'GET',
        types: [GET_Ubo_SUCCESS, GET_Ubo],
      },
    });
  };

export const FetchData =
  (body: FetchUBORequestBody) =>
  async (dispatch: any): Promise<uboDomestic> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/kradetails`,
        method: 'POST',
        types: [UBO_LISTING_SUCCESS, UBO_LISTING],
        body: {
          ...body,
          flowType: 'investor_with_pan',
        },
      },
    });
  };

export const FatcaMdmsData =
  (fatca: string) =>
  async (dispatch: any): Promise<FatcaMdms> => {
    return await dispatch({
      [CALL_API]: {
        url: `/mdms/${fatca}`,
        method: 'GET',
        types: [GET_Fatca_SUCCESS, GET_Fatca],
      },
    });
  };

export const validateNonIndividualContributorDetails = async (
  applicants: Partial<Applicant>[],
  folio_no: string | null | undefined,
  applicationSource: string | undefined,
  flowType: string,
  createdAt: string,
  fundFlowType: string,
  pushDataTo: string
) => {
  const schemaData = {
    folio_no: folio_no,
    applicationSource: applicationSource || 'digitalonboarding',
    applicants: applicants.map((applicant) => {
      const isServicesRequired = getIsServiceRequired(applicant);
      return {
        ...applicant,
        isServicesRequired: isServicesRequired,
      };
    }),
    flowType,
    fundFlowType,
  };
  try {
    await validateYupSchema(
      schemaData,
      IsInvestorWithPAN(flowType)
        ? NonIndividualContributorValidationSchemaWithPan(createdAt, ifPushToXalt(pushDataTo))
        : NonIndividualContributorValidationSchema(ifPushToXalt(pushDataTo)),
      true,
      schemaData
    );
  } catch (error) {
    console.log(yupToFormErrors(error));
    throw `Contributor details`;
  }
};
export const validateNonIndividualContactDetails = async (
  applicants: Partial<Applicant>[],
  countryDropdown: string[],
  flowType: string | undefined
) => {
  const schemaData = {
    applicants: applicants.map((applicant) => {
      const correspondence = getAddressData('correspondence', applicant.addresses);
      const permanent = getAddressData('permanent', applicant.addresses);
      const defaultPayload = {
        contactperson: applicant.contactperson
          ? {
              ...applicant.contactperson,
              countryNameAndCode: applicant.contactperson.countryNameAndCode
                ? applicant.contactperson.countryNameAndCode
                : 'India: +91',
            }
          : contactPersonObject,
        address: {
          correspondence,
        },
      };
      const permanentAddressPayload = correspondence.permanentAddressSameAsCorresponding
        ? defaultPayload
        : {
            ...defaultPayload,
            address: {
              ...defaultPayload.address,
              permanent: {
                ...permanent,
              },
              correspondence: {
                ...correspondence,
              },
            },
          };
      return permanentAddressPayload;
    }),
    countryDropdown: countryDropdown,
  };
  try {
    await validateYupSchema(
      schemaData,
      nonIndividualContactDetailsSchemaWithPan(flowType || ''),
      true,
      schemaData
    );
  } catch (error) {
    throw `Contact details`;
  }
};

export const validateNonIndividualDocumentDetails = async (
  applicants: Partial<Applicant>[],
  documentsData: individuals_Poa_nonIndividuals_Documents[],
  banks: Partial<Bank>[],
  applicationSource: string | undefined,
  countryList: mdmsCountriesList[],
  flowType: string,
  documentDeclarationCheck: boolean,
  fundFlowType: string
) => {
  const schemaData = {
    applicants: applicants.map((applicant, applicant_index) => {
      return {
        documents: documentsData
          .filter((document) => {
            if (applicant.amlCheck && document.documentType === 'compliance_document') {
              return;
            }
            if (
              applicationSource !== 'migration' &&
              document.documentType === 'migration_document'
            ) {
              return;
            }
            if (
              fatcaDocumentCheck(
                !applicant.wishToUploadFatcaDocument as boolean,
                document.documentType
              )
            ) {
              return;
            }
            if (
              document.documentType === 'edd_declaration' &&
              !eddDocumentCheck(countryList, applicant)
            ) {
              return;
            }
            return document;
          })
          .filter((ele) => ele)
          .map((_doc) => {
            if (applicationSource === 'migration' && _doc.documentType === 'migration_document') {
              return { ..._doc, required: 'true' };
            }
            if (
              _doc.documentType === 'edd_declaration' &&
              eddDocumentCheck(countryList, applicant)
            ) {
              return { ..._doc, required: 'true' };
            }
            if (
              fatcaDocumentCheck(applicant.wishToUploadFatcaDocument as boolean, _doc.documentType)
            ) {
              return { ..._doc, required: 'true' };
            }
            return _doc;
          })
          .filter((document) => {
            if (applicant.amlCheck && document.documentType === 'compliance_document') {
              return;
            }
            return document;
          })
          .filter((ele) => ele)
          // .map((doc) => ({ ...doc, required: 'true' }))
          .map((doc, index) => {
            const {
              documentType,
              documentName,
              multipleFiles,
              required,
              options,
              infoText,
              downloadTemplate,
            } = doc;
            const { documents: existingDocuments = [] } = applicant || {};
            const docsOfCurrentDocType = existingDocuments
              .filter((doc) => doc.documentType === documentType)
              .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId));
            return {
              documentType: documentType,
              documentName: documentName,
              documentsList: docsOfCurrentDocType.length
                ? docsOfCurrentDocType.map((doc, ind) => {
                    const {
                      documentName = '',
                      documentType = '',
                      documentId = '',
                      isActive = true,
                      file = undefined,
                    } = doc;
                    return {
                      documentType,
                      documentName,
                      documentId,
                      isActive,
                      file,
                      options,
                      required,
                      infoText,
                      downloadTemplate,
                      uniqueKey: (applicant_index.toString() +
                        '-' +
                        index.toString() +
                        '-' +
                        ind.toString()) as string,
                      errorOnUpload: document_object.errorOnUpload,
                    };
                  })
                : [
                    {
                      documentType,
                      documentName,
                      required,
                      options,
                      infoText,
                      downloadTemplate,
                      uniqueKey: (applicant_index.toString() +
                        '-' +
                        index.toString() +
                        '-' +
                        '0') as string,
                      ...document_object,
                    },
                  ],
              required,
              multipleFiles,
              options,
              infoText,
              downloadTemplate,
            };
          }),
        kraDocument: applicant.kraDocument,
        wishToUploadFatcaDocument: applicant.wishToUploadFatcaDocument,
      };
    }),
    banks: banks,
    flowType,
    fundFlowType,
    documentDeclarationCheck,
  };
  try {
    await validateYupSchema(schemaData, nonIndividualDocumentDetailsSchema, true, schemaData);
  } catch (error) {
    throw `Document details`;
  }
};
const fieldsTocheckForAuthorisedSignatories = [
  {
    key: 'name',
    label: 'Name',
    validateMulitple: false,
  },
  // {
  //   key: 'pan',
  //   label: 'PAN',
  //   validateMulitple: true,
  //   regex: individualPanRegex,
  //   regexMsg: 'Only Individual PANs are allowed',
  // },
  { key: 'mobile', label: 'Mobile Number', validateMulitple: true },
  {
    key: 'email',
    label: 'Email ID',
    validateMulitple: true,
    regex: emailRegex,
  },
  {
    key: 'designation',
    label: 'Designation',
    validateMulitple: false,
  },
];

export const validateNonIndividualAuthorisedSignatories = async (groups: Groups[]) => {
  try {
    groups.map((group) => {
      const getActiveSignatories = group.groupsignatories.filter((item) => item.isActive);
      const getCanEsignCount = getActiveSignatories.filter((item) => item.canEsign);
      if (!getActiveSignatories.length) {
        throw new AuthorisedErrors('Please add at least one Authorised Signatories');
      }
      if (!getCanEsignCount.length) {
        throw new AuthorisedErrors('Please Select a member for E-Sign in Authorised Signatories');
      }
      if (getCanEsignCount.length < group.threshold) {
        throw new AuthorisedErrors(
          'Authorised Signatories that can esign can not be less than the Total No. of required Authorised Signatories'
        );
      }
      getActiveSignatories.forEach((signatory, index) => {
        fieldsTocheckForAuthorisedSignatories.forEach((field) => {
          if (!signatory[field.key as keyof GroupSignatories] as unknown as string) {
            throw new AuthorisedErrors(`${field.label} is required for signatory ${index + 1}`);
          }
          // if (
          //   field.regex &&
          //   !field.regex.test(signatory[field.key as keyof GroupSignatories] as unknown as string)
          // ) {
          //   throw new AuthorisedErrors(
          //     field.regexMsg
          //       ? `${field.regexMsg} for signatory ${index + 1}`
          //       : `Please enter valid ${field.label} for signatory ${index + 1}`
          //   );
          // }
          if (field.validateMulitple) {
            const values = getActiveSignatories.filter(
              (vsignatory) =>
                (vsignatory[field.key as keyof GroupSignatories] as unknown as string) ===
                (signatory[field.key as keyof GroupSignatories] as unknown as string)
            );
            if (values.length > 1) {
              throw new AuthorisedErrors(
                `There is already same ${field.label} for an Authorised Signatory associated with this application`
              );
            }
          }
        });
      });
      return group;
    });
  } catch (error) {
    if (error instanceof AuthorisedErrors) {
      throw error;
    }
  }
};

const fieldsTocheckForUbosWithPan = [
  {
    key: 'panNumber',
    label: 'Taxpayer ID Number/PAN/Equivalent ID Number',
    validateMulitple: true,
    required: true,
  },
  {
    key: 'dob',
    label: 'Date of Birth',
    validateMulitple: false,
    required: true,
  },
  { key: 'name', label: 'Name of UBO', validateMulitple: false, required: true },
  {
    key: 'identificationType',
    label: 'Identification Type',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'percentageOfBeneficialInterest',
    label: 'Percentage of beneficial interest',
    validateMulitple: false,
    required: true,
  },
  // {
  //   key: 'typeOfUBO',
  //   label: 'UBO Type',
  //   validateMulitple: false,
  //   required: false,
  // },
  {
    key: 'countryOfTaxResidency',
    label: 'Country of Tax Residency',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'cpUboCode',
    label: 'CP/UBO Code',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'placeAndCountryOfBirth',
    label: 'Place & Country of Birth',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'occupation',
    label: 'Occupation',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'gender',
    label: 'Gender',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'nationality',
    label: 'Nationality',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'fatherName',
    label: 'Father Name',
    validateMulitple: false,
    required: true,
  },
  // {
  //   key: 'ckycNumber',
  //   label: 'CKYC Number',
  //   validateMulitple: true,
  //   required: false,
  // },
  {
    key: 'address2',
    label: 'Address 1',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'address3',
    label: 'Address 2',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'pincode',
    label: 'Pincode',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'city',
    label: 'City',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'state',
    label: 'State',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'country',
    label: 'Country',
    validateMulitple: false,
    required: true,
  },
];
const validateNonIndividualUboWithPan = async (
  applicants: Partial<Applicant>[],
  ubo_declaration_type: string,
  ubo_declaration_value: string,
  ubos: uboDomestic[],
  nationalityDropdown: string[],
  countryDropdown: string[]
) => {
  try {
    // const applicantsCkycNumbers = applicants?.map((applicant) => applicant.ckycNo);
    if (!ubo_declaration_type) {
      throw new UboErrors('Please Select Declaration Type in Declaration of Ubo');
    }
    if (!ubo_declaration_value) {
      throw new UboErrors('Please Select Declaration value in Declaration of Ubo');
    }
    if (ubo_declaration_type === 'none' && !ubos.filter((_item) => _item.isActive).length) {
      throw new UboErrors('Please Add Ultimate Beneficiary Owners(UBO)');
    }
    if (ubos.filter((_item) => _item.isActive).length) {
      const activeUbos = ubos.filter((_item) => _item.isActive);
      activeUbos.map((ubo) => {
        // if (ubo.ckycNumber && applicantsCkycNumbers.includes(ubo.ckycNumber)) {
        //   throw new UboErrors(
        //     `CKYC Number of ${ubo.name} should not be same as CKYC Number exist in Contributor Details`
        //   );
        // }
        if (!nationalityDropdown.includes(ubo.nationality || '')) {
          throw new UboErrors(`Invalid Nationality for ${ubo.name} in Declaration of Ubo`);
        }
        if (!countryDropdown.includes(ubo.country || '')) {
          throw new UboErrors(`Invalid Country for ${ubo.name} in Declaration of Ubo`);
        }
        if (!countryDropdown.includes(ubo.countryOfTaxResidency || '')) {
          throw new UboErrors(
            `Invalid Country of Tax Residency for ${ubo.name} in Declaration of Ubo`
          );
        }
        if (!occupationDetailsMasters.includes(ubo.occupation || '')) {
          throw new UboErrors(`Invalid Occupation for ${ubo.name} in Declaration of Ubo`);
        }
      });
      percentageErrorWithPan(ubos, true);
    }
    ubos
      .filter((_item) => _item.isActive)
      .forEach((ubo, index) => {
        fieldsTocheckForUbosWithPan.forEach((field) => {
          if ((!ubo[field.key as keyof uboDomestic] as unknown as string) && field.required) {
            if (
              !(
                (
                  field.key === 'percentageOfBeneficialInterest' &&
                  Number(ubo[field.key as keyof uboDomestic] as unknown as number) === 0
                )
                // &&
                // checkUBOTypeIsTrust(ubo['typeOfUBO' as keyof ubo] as unknown as string)
              )
            )
              throw new UboErrors(`${field.label} is required for ubo ${index + 1}`);
          }
          if (
            field.key === 'dob' &&
            (ubo[field.key as keyof uboDomestic] as unknown as string) &&
            isMinor(field.key)
          ) {
            throw new UboErrors(`Age should be greater than 18 for ubo ${index + 1}`);
          }
          // if (
          //   field.key === 'typeOfUBO' &&
          //   !Object.keys(UboTypeMaster).includes(
          //     ubo[field.key as keyof uboDomestic] as unknown as string
          //   )
          // ) {
          //   throw new UboErrors(`Invalid value for UBO Type`);
          // }
          if (field.key === 'percentageOfBeneficialInterest') {
            const percentageOfBeneficialInterest = ubo[
              field.key as keyof uboDomestic
            ] as unknown as number;
            if (
              percentageOfBeneficialInterest < 0
              // (percentageOfBeneficialInterest === 0
              //   &&
              //   !checkUBOTypeIsTrust(ubo['typeOfUBO' as keyof uboDomestic] as unknown as string))
            )
              throw new UboErrors(
                `Percentage Of Beneficial Interest should be greater than 0 for ubo ${index + 1}`
                //  ${
                //   checkUBOTypeIsTrust(ubo['typeOfUBO' as keyof uboDomestic] as unknown as string)
                //     ? 'or equal to '
                //     : ''
                // }
              );
          }
          if (
            field.key === 'percentageOfBeneficialInterest' &&
            (ubo[field.key as keyof uboDomestic] as unknown as number) > 100
          ) {
            throw new UboErrors(
              `Percentage Of Beneficial Interest must not exceed 100% for ubo ${index + 1}`
            );
          }
          if (field.validateMulitple) {
            const values = ubos.filter(
              (_ubo) =>
                (_ubo[field.key as keyof uboDomestic] as unknown as string) ===
                  (ubo[field.key as keyof uboDomestic] as unknown as string) &&
                (ubo[field.key as keyof uboDomestic] as unknown as string) &&
                (_ubo[field.key as keyof uboDomestic] as unknown as string)
            );
            if (values.length > 1) {
              throw new UboErrors(
                `There is already same ${field.label} for an Ubos associated with this application`
              );
            }
          }
        });
      });
  } catch (e) {
    if (e instanceof UboErrors) {
      throw e;
    }
  }
};

const fieldsTocheckForUbos = [
  {
    key: 'taxIdNumber',
    label: 'Taxpayer ID Number/Equivalent ID Number',
    validateMulitple: true,
    required: true,
  },
  {
    key: 'dob',
    label: 'Date of Birth',
    validateMulitple: false,
    required: true,
  },
  { key: 'name', label: 'Name of UBO', validateMulitple: false, required: true },
  {
    key: 'identificationType',
    label: 'Identification Type',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'percentageOfBeneficialInterest',
    label: 'Percentage of beneficial interest',
    validateMulitple: false,
    required: false,
  },
  {
    key: 'countryOfTaxResidency',
    label: 'Country of Tax Residency',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'cpUboCode',
    label: 'CP/UBO Code',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'placeAndCountryOfBirth',
    label: 'Place & Country of Birth',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'occupation',
    label: 'Occupation',
    validateMulitple: false,
    required: false,
  },
  {
    key: 'gender',
    label: 'Gender',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'nationality',
    label: 'Nationality',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'fatherName',
    label: 'Father Name',
    validateMulitple: false,
    required: false,
  },
  {
    key: 'ckycNumber',
    label: 'CKYC Number',
    validateMulitple: true,
    required: false,
  },
  {
    key: 'address2',
    label: 'Address 1',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'address3',
    label: 'Address 2',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'address4',
    label: 'Address 3',
    validateMulitple: false,
    required: false,
  },
  {
    key: 'pincode',
    label: 'Pincode',
    validateMulitple: false,
    required: false,
  },
  {
    key: 'city',
    label: 'City',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'state',
    label: 'State',
    validateMulitple: false,
    required: false,
  },
  {
    key: 'country',
    label: 'Country',
    validateMulitple: false,
    required: true,
  },
];
const validateNonIndividualUbo = async (
  applicants: Partial<Applicant>[],
  ubo_declaration_type: string,
  ubo_declaration_value: string,
  ubos: uboForeign[],
  nationalityDropdown: string[],
  countryDropdown: string[]
) => {
  try {
    const applicantsCkycNumbers = applicants?.map((applicant) => applicant.ckycNo);
    if (!ubo_declaration_type) {
      throw new UboErrors('Please Select Declaration Type in Declaration of Ubo');
    }
    if (!ubo_declaration_value) {
      throw new UboErrors('Please Select Declaration value in Declaration of Ubo');
    }
    if (ubo_declaration_type === 'none' && !ubos.filter((_item) => _item.isActive).length) {
      throw new UboErrors('Please Add Ultimate Beneficiary Owners(UBO)');
    }
    if (ubos.filter((_item) => _item.isActive).length) {
      const activeUbos = ubos.filter((_item) => _item.isActive);
      activeUbos.map((ubo) => {
        if (ubo.ckycNumber && applicantsCkycNumbers.includes(ubo.ckycNumber)) {
          throw new UboErrors(
            `CKYC Number of ${ubo.name} should not be same as CKYC Number exist in Contributor Details`
          );
        }
        if (!nationalityDropdown.includes(ubo.nationality || '')) {
          throw new UboErrors(`Invalid Nationality for ${ubo.name} in Declaration of Ubo`);
        }
        if (!countryDropdown.includes(ubo.country || '')) {
          throw new UboErrors(`Invalid Country for ${ubo.name} in Declaration of Ubo`);
        }
        if (!countryDropdown.includes(ubo.countryOfTaxResidency || '')) {
          throw new UboErrors(
            `Invalid Country of Tax Residency for ${ubo.name} in Declaration of Ubo`
          );
        }
        if (![...occupationDetailsMasters, ''].includes(ubo.occupation || '')) {
          throw new UboErrors(`Invalid Occupation for ${ubo.name} in Declaration of Ubo`);
        }
      });
      percentageError(ubos, true);
    }
    ubos
      .filter((_item) => _item.isActive)
      .forEach((ubo, index) => {
        fieldsTocheckForUbos.forEach((field) => {
          if ((!ubo[field.key as keyof uboForeign] as unknown as string) && field.required) {
            throw new UboErrors(`${field.label} is required for ubo ${index + 1}`);
          }
          if (
            field.key === 'dob' &&
            (ubo[field.key as keyof uboForeign] as unknown as string) &&
            isMinor(field.key)
          ) {
            throw new UboErrors(`Age should be greater than 18 for ubo ${index + 1}`);
          }
          // if (
          //   field.key === 'percentageOfBeneficialInterest' &&
          //   (ubo[field.key as keyof ubo] as unknown as number) <= 0
          // ) {
          //   throw new UboErrors(
          //     `Percentage Of Beneficial Interest should be greater 0 for ubo ${index + 1}`
          //   );
          // }
          if (
            field.key === 'percentageOfBeneficialInterest' &&
            (ubo[field.key as keyof uboForeign] as unknown as number) > 100
          ) {
            throw new UboErrors(
              `Percentage Of Beneficial Interest must not exceed 100% for ubo ${index + 1}`
            );
          }
          if (field.validateMulitple) {
            const values = ubos.filter(
              (_ubo) =>
                (_ubo[field.key as keyof uboForeign] as unknown as string) ===
                  (ubo[field.key as keyof uboForeign] as unknown as string) &&
                (ubo[field.key as keyof uboForeign] as unknown as string) &&
                (_ubo[field.key as keyof uboForeign] as unknown as string)
            );
            if (values.length > 1) {
              throw new UboErrors(
                `There is already same ${field.label} for an Ubos associated with this application`
              );
            }
          }
        });
      });
  } catch (e) {
    if (e instanceof UboErrors) {
      throw e;
    }
  }
};
export const nonIndividualFormValidForSubmission = async (
  application: ApplicationProps | null,
  documentsData: individuals_Poa_nonIndividuals_Documents[],
  mdmsCountriesList: nationaliyType,
  verifyPennydrop = true
) => {
  const {
    applicants = [],
    banks = [],
    groups = [],
    ubo_declaration_type = '',
    ubo_declaration_value = '',
    ubos = [],
    applicationType = '',
    folio_no,
    applicationSource,
    flowType = '',
    documentDeclarationCheck = false,
    createdAt = '',
    fundFlowType = '',
  } = application || {};
  const mergedCountryList = mdmsCountriesList.countries.concat(mdmsCountriesList.eddCountries);
  const nationalityDropdown = mergedCountryList.map((list) => list?.nationality);
  const countryDropdown = mergedCountryList.map((list) => list?.name);
  try {
    await validateNonIndividualContributorDetails(
      applicants,
      folio_no,
      applicationSource,
      flowType,
      createdAt,
      fundFlowType,
      application?.pushDataTo || ''
    );
    await validateNonIndividualContactDetails(applicants, countryDropdown, flowType || '');
    await validateBankDetails(
      banks,
      verifyPennydrop,
      applicationType,
      applicants,
      mdmsCountriesList?.ibanCountries || [],
      createdAt,
      flowType,
      fundFlowType,
      application?.paymentModeDeclaration || false
    );
    await validateNonIndividualDocumentDetails(
      applicants,
      documentsData,
      banks,
      application?.applicationSource,
      mdmsCountriesList?.eddCountries,
      flowType,
      documentDeclarationCheck,
      fundFlowType
    );
    await validateNonIndividualAuthorisedSignatories(groups);
    IsInvestorWithPAN(flowType)
      ? await validateNonIndividualUboWithPan(
          applicants,
          ubo_declaration_type,
          ubo_declaration_value,
          ubos as uboDomestic[],
          nationalityDropdown,
          countryDropdown
        )
      : await validateNonIndividualUbo(
          applicants,
          ubo_declaration_type,
          ubo_declaration_value,
          ubos as uboForeign[],
          nationalityDropdown,
          countryDropdown
        );
  } catch (error) {
    if (error instanceof UboErrors) {
      throw (error as UboErrors).message;
    }
    if (error instanceof AuthorisedErrors) {
      throw (error as AuthorisedErrors).message;
    }
    if (error instanceof BankError) {
      throw (error as BankError).message;
    }
    throw `In ${error}, the required fields are not filled.`;
  }
};

export const addPhysicalApplications =
  (body: any) =>
  async (dispatch: any): Promise<any> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/applications/bulk-upload-application`,
        method: 'POST',
        types: [CREATE_PHYSICAL_APPLICATION_SUCCESS, CREATE_PHYSICAL_APPLICATION],
        body,
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });
  };
